import React, {useMemo} from 'react';
import {UserStatusEnum, UserTypeEnum} from 'src/api/ProactApiClient';
import type {CheckboxListProps} from 'src/design/atoms/CheckboxList';
import {CheckboxList} from 'src/design/atoms/CheckboxList';
import {useGetPersonnelSelectOptionsQuery} from 'src/redux/queries/personnel';
import type {IListItem} from 'src/types/Form';

export type PersonnelCheckboxListProps = Omit<CheckboxListProps, 'values'>;
export const PersonnelCheckboxList: React.FC<PersonnelCheckboxListProps> = ({
  ...other
}) => {
  const {data, isFetching, isLoading} = useGetPersonnelSelectOptionsQuery({
    start: 0,
    length: 10000,
    active: [UserStatusEnum.Active],
    userTypes: [UserTypeEnum.Contractor, UserTypeEnum.Employee],
    superviserOnly: false,
  });

  const values = useMemo(
    () =>
      (data?.data ?? []).map(
        i => ({label: i.label, value: String(i.id)} as IListItem)
      ),
    [data?.data]
  );

  return (
    <CheckboxList
      {...other}
      multiSelectProps={{limit: 20}}
      disabled={isLoading || isFetching || other.disabled}
      values={values}
    />
  );
};
